import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { HR_CATEGORIES, HR_STATUS } from "@/lib/hr";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function HRReports() {
  const [tab, setTab] = useState("issues");
  const [issues, setIssues] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());
  const [cat, setCat] = useState("salary");
  const [missing, setMissing] = useState([]);

  const loadIssues = () => api.get("/hrdoc/reports").then((r) => setIssues(r.data.items));
  const loadMissing = () => api.get("/hrdoc/reports/missing-periods", { params: { year, category: cat } }).then((r) => setMissing(r.data.items));

  useEffect(() => { loadIssues(); }, []);
  useEffect(() => { if (tab === "missing") loadMissing(); /* eslint-disable-next-line */ }, [tab, year, cat]);

  return (
    <div className="space-y-6" data-testid="hr-reports">
      <div>
        <h1 className="text-3xl font-heading font-semibold">Rapporten</h1>
        <p className="text-muted-foreground mt-1">Onvolledige dossiers en ontbrekende periodes.</p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="issues" data-testid="hr-tab-issues">Aandachtspunten</TabsTrigger>
          <TabsTrigger value="missing" data-testid="hr-tab-missing">Ontbrekende periodes</TabsTrigger>
        </TabsList>

        <TabsContent value="issues" className="mt-4">
          <Card><CardContent className="p-5">
            <Table>
              <TableHeader><TableRow><TableHead>Werknemer</TableHead><TableHead>Categorie</TableHead><TableHead>Periode</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
              <TableBody>
                {issues.map((g, i) => {
                  const st = HR_STATUS[g.status] || HR_STATUS.problem;
                  return (
                    <TableRow key={i}>
                      <TableCell className="font-medium">{g.employee_name || "Onbekend"}</TableCell>
                      <TableCell>{HR_CATEGORIES[g.category]}</TableCell>
                      <TableCell>{g.period_key || "—"}</TableCell>
                      <TableCell><Badge className={st.cls}>{st.label}</Badge></TableCell>
                    </TableRow>
                  );
                })}
                {issues.length === 0 && <TableRow><TableCell colSpan={4} className="text-center text-muted-foreground py-8">Geen aandachtspunten — alles is compleet.</TableCell></TableRow>}
              </TableBody>
            </Table>
          </CardContent></Card>
        </TabsContent>

        <TabsContent value="missing" className="mt-4 space-y-4">
          <div className="flex items-end gap-3 flex-wrap">
            <div><Label>Jaar</Label><Input type="number" className="w-28" data-testid="hr-missing-year" value={year} onChange={(e) => setYear(Number(e.target.value))} /></div>
            <div><Label>Categorie</Label>
              <Select value={cat} onValueChange={setCat}>
                <SelectTrigger className="w-52" data-testid="hr-missing-cat"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="salary">Lonen</SelectItem>
                  <SelectItem value="holiday_pay">Vakantiegeld</SelectItem>
                  <SelectItem value="year_end_bonus">Eindejaarspremie</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <Card><CardContent className="p-5">
            <Table>
              <TableHeader><TableRow><TableHead>Werknemer</TableHead><TableHead>Ontbrekende periode</TableHead><TableHead>Opmerking</TableHead></TableRow></TableHeader>
              <TableBody>
                {missing.map((m, i) => (
                  <TableRow key={i}>
                    <TableCell className="font-medium">{m.employee_name}</TableCell>
                    <TableCell><Badge variant="outline" className="text-amber-600 border-amber-300">{m.period_key}</Badge></TableCell>
                    <TableCell className="text-muted-foreground text-sm">{m.note}</TableCell>
                  </TableRow>
                ))}
                {missing.length === 0 && <TableRow><TableCell colSpan={3} className="text-center text-muted-foreground py-8">Geen ontbrekende periodes voor dit jaar.</TableCell></TableRow>}
              </TableBody>
            </Table>
          </CardContent></Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
